<template>
    <!-- table -->
    <div class="qt-full-table">
      <table>
        <tr>
          <th>Details</th>
          <th>{{ currentYear }}</th>
          <th></th>
        </tr>
        <tr>
          <td>Remaining Vacation Days Last Year</td>
          <td>{{(vacationReportOverview.remainingLastyearVacation || 0).toFixed(2)}}</td>
          <td></td>
        </tr>
        <tr>
          <td>Annual Vacation Entitlement</td>
          <td>{{(vacationReportOverview.allowedThisyearVacation || 0).toFixed(2)}}</td>
          <td></td>
        </tr>
        <tr>
          <td>Total Vacation current year</td>
          <td>{{(vacationReportOverview.sumOfVacationDays || 0).toFixed(2)}}</td>
          <td></td>
        </tr>
        <tr>
          <td>Number of vacation days approved</td>
          <td>{{(vacationReportOverview.plannedVacationDays || 0).toFixed(2)}}</td>
          <td></td>
        </tr>
        <tr>
          <td>Remaining (Not planned) Vacation Days</td>
          <td>{{(vacationReportOverview.remainingVacationDays || 0).toFixed(2)}}</td>
          <td></td>
        </tr>
        <tr>
          <td>Pending Vacation Request Days</td>
          <td>{{(vacationReportOverview.numberOfPendingVacations || 0).toFixed(2)}}</td>
          <td></td>
        </tr>
        <tr>
          <td>Special Leaves</td>
          <td>{{(vacationReportOverview.specialLeaves || 0).toFixed(2)}}</td>
          <td></td>
        </tr>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        currentYear: new Date().getFullYear().toString()
      };
    },
    beforeMount(){
    this.$store.dispatch("VacationReportOverview");
    },
    computed: {
            vacationReportOverview: function () {
                return this.$store.state.qtimeReports.vacationReportOverview;
            }
    }
  };
  </script>